export const formBuilder = {
  title: 'Űrlapok és Listák Szerkesztő',
  subtitle: 'Egyedi űrlapok létrehozása adatgyűjtéshez és listák adatmegjelenítéshez',
  fieldPalette: 'Mező Paletta',
  fieldPaletteDescription: 'Húzd a mezőket a vászonra vagy kattints a hozzáadáshoz',
  untitledForm: 'Névtelen Form',
  untitledList: 'Névtelen Lista',
  selectField: 'Válasszon ki egy mezőt a tulajdonságok szerkesztéséhez',
  selectFieldDescription: 'Válassz egy mezőt a vászonról a tulajdonságok és beállítások testreszabásához',
  clickToEdit: 'Kattints a szerkesztéshez',
  editTitle: 'Cím szerkesztése',
  sectionNamePlaceholder: 'Szakasz neve...',
  dragToReorder: 'Húzd át a sorrendhez',
  unassignedFields: 'Nem Hozzárendelt Mezők',
  unassignedFieldsDescription: 'Szakaszhoz nem rendelt mezők - húzd őket szakaszokba',
  validationHelpText: 'Nincsenek validációs szabályok beállítva. Adj hozzá szabályokat a felhasználói bemenet ellenőrzéséhez.',

  confirmDelete: {
    title: 'Mező Törlése',
    message: 'Biztosan törölni szeretné ezt a mezőt? Ez a művelet nem vonható vissza.',
    confirm: 'Mező Törlése'
  },

  confirmDeleteSection: {
    title: 'Szakasz Törlése',
    message: 'Biztosan törölni szeretné ezt a szakaszt és az összes mezőjét? Ez a művelet nem vonható vissza.',
    confirm: 'Szakasz Törlése'
  },
  confirmDeleteTemplate: {
    title: 'Sablon Törlése',
    message: 'Biztosan törölni szeretné ezt a sablont? Ez a művelet nem vonható vissza.',
    confirm: 'Sablon Törlése'
  },

  quickGuide: {
    formsTitle: 'Hozza Létre Az Első Űrlapját',
    formsDescription: 'Az űrlapok lehetővé teszik adatok gyűjtését a felhasználóktól. Különféle mező típusokat adhat hozzá, mint szöveg, email, legördülő menük és még sok más.',
    listsTitle: 'Hozza Létre Az Első Listáját',
    listsDescription: 'A listák lehetővé teszik az összegyűjtött adatok szervezett táblázatokban való megjelenítését. Testreszabhatja az oszlopokat, szűrőket adhat hozzá és formázhatja az adatok megjelenítését.'
  },
  newForm: 'Új Form',
  preview: 'Előnézet',
  settings: 'Beállítások',
  forms: 'Formok',
  searchPlaceholder: 'Sablonok keresése...',
  emptyForm: 'Még nincsenek mezők',
  emptyFormDescription: 'Húzza át a mezőket a palettáról a kezdéshez',
  emptySection: 'Nincsenek mezők ebben a szakaszban',
  emptySectionDescription: 'Húzza ide a mezőket, hogy hozzáadja őket ehhez a szakaszhoz',
  emptySectionDescriptionCross: 'Húzza ide a mezőket a palettáról vagy más szakaszokból',
  dropFieldHere: 'Ejtse ide a mezőt',
  dropHere: 'Ejtse ide a mezőt',
  addSection: 'Szakasz Hozzáadása',
  
  categories: {
    basic: 'Alap Mezők',
    advanced: 'Haladó Mezők',
    lookup: 'Keresési Mezők',
    special: 'Speciális Mezők'
  },
  
  fieldTypes: {
    text: 'Szöveg Bevitel',
    email: 'Email',
    phone: 'Telefon',
    number: 'Szám',
    currency: 'Pénznem',
    percentage: 'Százalék',
    date: 'Dátum',
    datetime: 'Dátum és Idő',
    time: 'Idő',
    textarea: 'Szövegterület',
    select: 'Legördülő',
    multiselect: 'Többszörös Választás',
    radio: 'Rádió Gombok',
    checkbox: 'Jelölőnégyzetek',
    switch: 'Kapcsoló',
    file: 'Fájl Feltöltés',
    image: 'Kép Feltöltés',
    color: 'Színválasztó',
    range: 'Tartomány Csúszka',
    rating: 'Csillag Értékelés',
    signature: 'Aláírás',
    address: 'Cím',
    customer_lookup: 'Ügyfél Keresés',
    product_lookup: 'Termék Keresés',
    user_lookup: 'Felhasználó Keresés',
    organization_lookup: 'Szervezet Keresés',
    custom_object: 'Egyedi Objektum'
  },

  fieldDescriptions: {
    text: 'Egysoros szöveg bevitel',
    email: 'Email cím validációval',
    phone: 'Telefonszám bevitel',
    number: 'Numerikus bevitel',
    currency: 'Pénzösszeg',
    percentage: 'Százalék érték',
    date: 'Dátumválasztó',
    datetime: 'Dátum és idő választó',
    time: 'Időválasztó',
    textarea: 'Többsoros szöveg bevitel',
    select: 'Egyszeres választás legördülő',
    multiselect: 'Többszörös választás legördülő',
    radio: 'Egyszeres választás rádió gombok',
    checkbox: 'Többszörös választás jelölőnégyzetek',
    switch: 'Be/ki kapcsoló',
    file: 'Fájl feltöltés mező',
    image: 'Kép feltöltés előnézettel',
    color: 'Szín kiválasztás',
    range: 'Numerikus tartomány csúszka',
    rating: 'Csillag értékelés bevitel',
    signature: 'Digitális aláírás tábla',
    address: 'Cím bevitel automatikus kiegészítéssel',
    customer_lookup: 'Ügyfél keresés és kiválasztás',
    product_lookup: 'Termék keresés és kiválasztás',
    user_lookup: 'Felhasználó keresés és kiválasztás',
    organization_lookup: 'Szervezet keresés és kiválasztás',
    custom_object: 'Egyedi objektum'
  },
  
  properties: {
    title: 'Mező Tulajdonságok',
    general: 'Általános',
    validation: 'Validáció',
    options: 'Opciók',
    appearance: 'Megjelenés',
    incompatibleRule: 'Ez a szabály nem kompatibilis a jelenlegi mezőtípussal',
    validationHelpText: 'Ehhez a mezőtípushoz elérhető szabályok',
    conditional: 'Feltételes Logika',
    fields: 'mező',
    
    label: 'Címke',
    name: 'Mező Neve',
    placeholder: 'Helyőrző',
    description: 'Leírás',
    required: 'Kötelező',
    defaultValue: 'Alapértelmezett Érték',
    width: 'Szélesség',
    
    validationRules: 'Validációs Szabályok',
    addValidation: 'Validáció Hozzáadása',
    validationRule: 'Szabály',
    validationValue: 'Érték',
    validationMessage: 'Hibaüzenet',
    minLength: 'Minimum Hossz',
    maxLength: 'Maximum Hossz',
    minValue: 'Minimum Érték',
    maxValue: 'Maximum Érték',
    pattern: 'Minta',
    customValidation: 'Egyedi Validáció',
    category: 'Kategória',
    categoryPlaceholder: 'Kategória megadása...',
    tags: 'Címkék',
    tagsPlaceholder: 'Címkék vesszővel elválasztva...',
    fileSettings: 'Fájl Beállítások',
    multipleFiles: 'Több fájl engedélyezése',
    maxFileSize: 'Max Fájlméret (MB)',
    acceptedTypes: 'Elfogadott Fájltípusok',
    acceptedTypesHelp: 'MIME típusokat (pl. image/*) vagy fájlkiterjesztéseket (pl. .pdf,.doc) használjon',
    hidden: 'Rejtett mező',
    
    optionValue: 'Érték',
    optionLabel: 'Címke',
    addOption: 'Opció Hozzáadása',
    removeOption: 'Opció Eltávolítása',
    noOptions: 'Még nincsenek opciók hozzáadva. Kattints az "Opció Hozzáadása" gombra a kezdéshez.',
    
    fieldWidth: {
      full: 'Teljes Szélesség',
      half: 'Fél Szélesség',
      third: 'Harmad Szélesség',
      quarter: 'Negyed Szélesség'
    },
    
    widthFull: 'Teljes Szélesség',
    widthHalf: 'Fél Szélesség',
    widthThird: 'Harmad Szélesség',
    widthQuarter: 'Negyed Szélesség'
  },
  
  validation: {
    required: 'Ez a mező kötelező',
    email: 'Érvényes email címet adjon meg',
    min: 'Minimum érték: {{min}}',
    max: 'Maximum érték: {{max}}',
    minLength: 'Minimum hossz: {{minLength}} karakter',
    maxLength: 'Maximum hossz: {{maxLength}} karakter',
    pattern: 'Érvénytelen formátum',
    checkboxRequired: 'Ezt a jelölőnégyzetet be kell jelölni',
    switchRequired: 'Ezt a kapcsolót be kell kapcsolni'
  },

  share: {
    title: 'Űrlap Megosztása',
    description: 'Ossza meg ezt az űrlapot másokkal',
    publicAccess: 'Nyilvános Hozzáférés',
    publicEnabled: 'Bárki kitöltheti ezt az űrlapot a linkkel',
    publicDisabled: 'Csak jogosult felhasználók férhetnek hozzá',
    publicLink: 'Nyilvános Link',
    settings: 'Megosztási Beállítások',
    allowAnonymous: 'Névtelen kitöltés engedélyezése',
    allowAnonymousDesc: 'A felhasználók email megadása nélkül is kitölthetik',
    requireEmail: 'Email cím kötelező',
    requireEmailDesc: 'A felhasználóknak meg kell adniuk az email címüket',
    maxSubmissions: 'Maximum kitöltések száma (opcionális)',
    unlimited: 'Korlátlan',
    submitted: 'kitöltve',
    enabled: 'Nyilvános megosztás bekapcsolva',
    disabled: 'Nyilvános megosztás kikapcsolva'
  },

  publicForm: {
    error: 'Űrlap Nem Elérhető',
    submitSuccess: 'Űrlap Sikeresen Elküldve!',
    submitSuccessMessage: 'Köszönjük a kitöltést. A válaszát rögzítettük.'
  },
  
  messages: {
    createSuccess: 'Form sablon sikeresen létrehozva',
    createSuccessWithList: 'Form sablon és alapértelmezett lista sikeresen létrehozva',
    updateSuccess: 'Form sablon sikeresen frissítve',
    deleteSuccess: 'Sablon sikeresen törölve',
    duplicateSuccess: 'Sablon sikeresen duplikálva',
    defaultListError: 'Nem sikerült létrehozni az alapértelmezett listát',
    noListsForForm: 'Nem található lista ehhez a formhoz. Hozzon létre egyet először.',
    listsLoaded: 'Listák betöltve ehhez a formhoz',
    loadListsError: 'Nem sikerült betölteni a listákat ehhez a formhoz'
  },

  templates: {
    createList: 'Lista Létrehozása',
    viewLists: 'Listák Megtekintése',
    duplicate: 'Duplikálás',
    noTemplates: 'Nem találhatók sablonok',
    createFirst: 'Hozza létre az első sablonját a kezdéshez',
    lastModified: 'Utoljára módosítva',
    createdBy: 'Létrehozta',
    version: 'Verzió',
    status: 'Státusz',
    active: 'Aktív',
    inactive: 'Inaktív',
    export: 'Exportálás',
    import: 'Importálás'
  },

  listViewer: {
    viewData: 'Adatok Megtekintése',
    noData: 'Nem találhatók beküldések',
    noDataDescription: 'A beküldések itt jelennek meg, miután kitöltik a formot',
    submissions: 'beküldés',
    submission: 'beküldés',
    from: '-',
    submittedBy: 'Beküldő',
    showing: 'Megjelenítve',
    to: '-',
    of: 'összesen',
    results: 'eredmény',
    search: 'Keresés...',
    filters: 'Szűrők',
    export: 'Exportálás',
    actions: 'Műveletek',
    loadError: 'Nem sikerült betölteni a listát',
    loadSubmissionsError: 'Nem sikerült betölteni a beküldéseket',
    notFound: 'A lista nem található',
    notFoundDescription: 'A kért lista nem található'
  },
  
  errors: {
    loadFailed: 'Sablonok betöltése sikertelen',
    saveFailed: 'Sablon mentése sikertelen',
    deleteFailed: 'Sablon törlése sikertelen',
    invalidField: 'Érvénytelen mező konfiguráció'
  },

  sectionProperties: {
    title: 'Szakasz Tulajdonságok',
    basic: 'Alap Tulajdonságok',
    appearance: 'Megjelenés',
    order: 'Szakasz Sorrend',
    color: 'Szakasz Színe',
    collapsible: 'Összecsukható szakasz',
    moveUp: 'Felfelé',
    moveDown: 'Lefelé'
  },

  formSettings: {
    title: 'Form Beállítások',
    subtitle: 'Állítsd be a form viselkedését és megjelenését',
    general: 'Általános Beállítások',
    appearance: 'Megjelenés Beállítások', 
    permissions: 'Jogosultság Beállítások',
    generalTab: 'Általános',
    appearanceTab: 'Megjelenés',
    permissionsTab: 'Jogosultságok',
    basicInfo: 'Alapinformációk',
    formBehavior: 'Form Viselkedés',
    displaySettings: 'Megjelenítési Beállítások',
    accessControl: 'Hozzáférés Vezérlés',
    formTitle: 'Form Címe',
    formDescription: 'Form Leírása',
    submitButtonText: 'Küldés Gomb Szövege',
    cancelButtonText: 'Mégse Gomb Szövege',
    allowDrafts: 'Piszkozatok mentésének engedélyezése',
    multiStep: 'Többlépéses form',
    showProgressBar: 'Haladási sáv megjelenítése',
    canView: 'Ki tekintheti meg ezt a formot?',
    canEdit: 'Ki szerkesztheti ezt a formot?',
    canSubmit: 'Ki küldheti be ezt a formot?',
    permissionsHelp: 'Jogosultságok formátuma:'
  }
};

export const formRenderer = {
  templateNotFound: 'Form sablon nem található',
  loadError: 'Hiba a form sablon betöltése közben',
  submitSuccess: 'Form sikeresen elküldve',
  submitError: 'Hiba a form elküldése közben',
  noTemplate: 'Nincs elérhető form sablon'
};

export const formFiller = {
  title: 'Form Kitöltése',
  subtitle: 'Töltse ki az alábbi formot',
  templateNotFound: 'Form sablon nem található',
  noPermission: 'Nincs jogosultsága ennek a formnak a kitöltéséhez',
  notAvailableOnPortal: 'Ez a form nem elérhető az ügyfélportálon',
  noAccess: 'Nincs hozzáférése ehhez a formhoz',
  loadError: 'Hiba a form sablon betöltése közben',
  errorTitle: 'Nem sikerült betölteni a formot',
  draftSaved: 'Piszkozat sikeresen mentve',
  submitted: 'Form sikeresen elküldve!',
  submitSuccessMessage: 'Köszönjük a beküldést. A válaszát rögzítettük.',
  submitError: 'Hiba történt a form beküldése során. Kérjük, próbálja újra.'
};

export const formSubmissions = {
  title: 'Form Beküldések',
  subtitle: 'Form beküldések kezelése és áttekintése',
  loadError: 'Hiba a form beküldések betöltése közben',
  searchPlaceholder: 'Keresés a beküldésekben...',
  allStatuses: 'Minden Státusz',
  draft: 'Piszkozat',
  submitted: 'Beküldve',
  approved: 'Jóváhagyva',
  rejected: 'Elutasítva',
  processing: 'Feldolgozás alatt',
  noSubmissions: 'Nincs beküldés',
  noResults: 'Nincs a szűrőknek megfelelő beküldés',
  noSubmissionsYet: 'Még nincsenek form beküldések',
  form: 'Form',
  submittedBy: 'Beküldte',
  status: 'Státusz',
  submittedAt: 'Beküldve',
  actions: 'Műveletek',
  approveSubmission: 'Beküldés Jóváhagyása',
  rejectSubmission: 'Beküldés Elutasítása',
  reviewNotes: 'Értékelési Megjegyzések (Opcionális)',
  reviewNotesPlaceholder: 'Adjon hozzá megjegyzéseket a döntéséről...',
  approve: 'Jóváhagyás',
  reject: 'Elutasítás',
  approveSuccess: 'Beküldés jóváhagyva',
  rejectSuccess: 'Beküldés elutasítva',
  reviewError: 'Hiba a beküldés értékelése közben'
};

export const myForms = {
  title: 'Saját Űrlapok',
  subtitle: 'Az általad létrehozott és kitölthető űrlapok',
  loadError: 'Hiba az űrlapok betöltése közben',
  searchPlaceholder: 'Keresés az űrlapokban...',
  createNew: 'Új Űrlap Létrehozása',
  createFirst: 'Első Űrlap Létrehozása',
  noForms: 'Még nincsenek létrehozott űrlapok',
  noFormsDescription: 'Hozd létre az első űrlapodat a kezdéshez',
  noResults: 'Nincs a szűrőknek megfelelő űrlap',
  noResultsDescription: 'Próbáld módosítani a keresést vagy szűrőket',
  fields: 'mező',
  submissions: 'beküldés',
  fill: 'Kitöltés',
  filters: {
    all: 'Minden Űrlap',
    available: 'Kitölthető',
    draft: 'Piszkozattal',
    submitted: 'Beküldött',
    completed: 'Befejezett'
  },
  status: {
    available: 'Kitölthető',
    draft: 'Piszkozat Mentve',
    submitted: 'Beküldve',
    approved: 'Jóváhagyva',
    rejected: 'Elutasítva',
    processing: 'Feldolgozás alatt'
  }
};

export const listBuilder = {
  title: 'Lista Szerkesztő',
  preview: 'Előnézet',
  newList: 'Új Lista',
  lists: 'Listák',
  columns: 'Oszlopok',
  filters: 'Szűrők',
  settings: 'Beállítások',
  untitledList: 'Névtelen Lista',
  listName: 'Lista Neve',
  listDescription: 'Lista Leírása',
  noColumns: 'Nincsenek Oszlopok',
  addColumnsFromPalette: 'Adjon hozzá oszlopokat a bal oldali palettáról a lista építéséhez',
  columnTypesTitle: 'Oszlop Típusok',
  dragColumnTypes: 'Kattintson az oszlop típusokra a listához adáshoz',
  selectColumn: 'Válasszon Oszlopot',
  selectColumnDescription: 'Válasszon egy oszlopot a táblázatból a tulajdonságok testreszabásához',
  columnProperties: 'Oszlop Tulajdonságok',
  columnLabel: 'Címke',
  fieldName: 'Mező Neve',
  columnWidth: 'Szélesség (px)',
  columnOptions: 'Opciók',
  formatting: 'Formázás',
  comingSoon: 'Lista Szerkesztő Hamarosan',
  comingSoonDescription: 'A lista szerkesztő jelenleg fejlesztés alatt áll. Ez lehetővé teszi majd egyedi adattáblák és nézetek létrehozását.',
  previewComingSoon: 'Lista Előnézet Hamarosan',
  previewComingSoonDescription: 'Az előnézet funkció elérhető lesz, amint a lista szerkesztő elkészül.',
  
  columnTypes: {
    text: 'Szöveg',
    number: 'Szám',
    currency: 'Pénznem',
    date: 'Dátum',
    datetime: 'Dátum és Idő',
    boolean: 'Igen/Nem',
    status: 'Státusz',
    priority: 'Prioritás',
    progress: 'Haladás',
    image: 'Kép',
    link: 'Link',
    actions: 'Műveletek'
  },
  
  properties: {
    field: 'Mező',
    label: 'Címke',
    type: 'Típus',
    width: 'Szélesség',
    sortable: 'Rendezhető',
    filterable: 'Szűrhető',
    searchable: 'Kereshető',
    format: 'Formátum',
    prefix: 'Előtag',
    suffix: 'Utótag'
  },
  
  messages: {
    createSuccess: 'Lista sablon sikeresen létrehozva',
    updateSuccess: 'Lista sablon sikeresen frissítve'
  },

  quickGuide: {
    listsTitle: 'Hozza Létre Az Első Listáját',
    listsDescription: 'A listák lehetővé teszik az összegyűjtött adatok szervezett táblázatokban való megjelenítését. Testreszabhatja az oszlopokat, szűrőket adhat hozzá és formázhatja az adatok megjelenítését.'
  },

  listViewer: {
    notFound: 'Lista nem található',
    notFoundDescription: 'A keresett lista nem található',
    loadError: 'Hiba a lista betöltése közben',
    loadSubmissionsError: 'Hiba a beküldések betöltése közben',
    submission: 'beküldés',
    submissions: 'beküldés',
    search: 'Keresés...',
    filters: 'Szűrők',
    export: 'Exportálás',
    noData: 'Nincs beküldés',
    noDataDescription: 'A beküldések itt jelennek meg, amint az űrlapot kitöltik',
    actions: 'Műveletek',
    submittedBy: 'Beküldte',
    showing: 'Megjelenítve',
    to: '-',
    of: 'összesen',
    results: 'eredmény',
    submissionDetails: 'Beküldés részletei',
    exportSuccess: 'Exportálás sikeres',
    exportError: 'Exportálás sikertelen'
  }

};
